// src/components/CityStats.js
import React from 'react';

const CityStats = ({ statistics }) => {
  const { totalDistricts, totalSchools, problemSchools, totalProblems } = statistics;

  return (
    <div className="stats-grid" id="city-stats">
      <div className="stat-card">
        <div className="stat-label">Районов</div>
        <div className="stat-value">{totalDistricts}</div>
      </div>
      <div className="stat-card">
        <div className="stat-label">Образовательных учреждений</div>
        <div className="stat-value">{totalSchools}</div>
      </div>
      <div className="stat-card">
        <div className="stat-label">ОУ с проблемами</div>
        <div className={`stat-value ${problemSchools > 0 ? 'warning' : 'success'}`}>
          {problemSchools}
        </div>
      </div>
      <div className="stat-card">
        <div className="stat-label">Всего проблем</div>
        <div className={`stat-value ${totalProblems > 0 ? 'error' : 'success'}`}>
          {totalProblems}
        </div>
      </div>
    </div>
  );
};

export default CityStats;